import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditEmployeeReady} from '../redux/employees'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
import  {ValidateEmail ,ValidatePhone,ValidateAadhaar} from '../../../common/ValidationFunctions/CommonValidation'


import DateTimeField from "react-bootstrap-datetimepicker";

import * as Helpers from '../../../common/helpers'


import {EntityType,WorkLocations,Kitchens} from '../../../common/DropDowns/index'




import {Cities,Designations,DepartmentTeams,RAG,Vaccination,Departments,Employees,Gender,AccountType,LoginType} from './DropDowns/index'

class AddEditEmployee extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,
        disabledFlag:true,
        isValidEmployee:true,
        errorMsg:"",

        name: "",
        code: "",
        email: "",
        mobile: "",
        cityId:"",
        dob:new Date(),
        doj:new Date(),
        designationId:"",
        departmentId:"",
        departmentTeamId:"",
        workLocationId:"",
        workKitchenId:"",
        reportingManagerId:"",
        altMobile:"",
        address:"",
        category:"",        
        rag:"",         
        status:"",         
        workLocationType:"",     
        gender:"",
        vaccination:"",
        selectedRoles:[],
        rolesList: [],
        deletedRoles:[],
        employeeData:{},
        accountHolderName:"",          
        accountNumber:"",
        ifscCode:"",
        bankName:"",
        accountType:"",
        loginType:"Email",
        aadhaarNo:"",
        panNo:"Email",

        panNoErrorText: false,
        panNoErrorData: '',  

        aadhaarNoErrorText: false,
        aadhaarNoErrorData: '', 

        loginTypeErrorText: false,
        loginTypeErrorData: '',     
        
        accountTypeErrorText: false,
        accountTypeErrorData: '',       
   
        bankNameErrorText: false,
        bankNameErrorData: '',   
        

        ifscCodeErrorText: false,
        ifscCodeErrorData: '',      

        accountNumberErrorText: false,
        accountNumberErrorData: '',     
    
        accountHolderNameErrorText: false,
        accountHolderNameErrorData: '',            

        addressErrorText: false,
        addressErrorData: '',

        altMobileErrorText: false,
        altMobileErrorData: '', 

        nameErrorText: false,
        nameErrorData: '',

        codeErrorText: false,
        codeErrorData: '',

        genderErrorText: false,
        gendercodeErrorData: '',

        mobileErrorText: false,
        mobileErrorData: '',

        emailErrorText: false,
        emailErrorData: '',

        cityIdErrorText: false,
        cityIdErrorData: '',

        designationIdErrorText: false,
        designationIdErrorData: '',

        reportingManagerIdErrorText: false,
        reportingManagerIdErrorData: '',

       

        departmentIdErrorText: false,
        departmentIdData: '',

        departmentTeamIdErrorText: false,
        departmentTeamIdData: '',

        statusErrorText: false,
        statusData: '',

        workLocationIdErrorText: false,
        workLocationIdErrorData: '',

        workKitchenIdErrorText: false,
        workKitchenIdErrorData: '',

        categoryErrorText: false,
        categoryErrorData: '',

        ragErrorText: false,
        ragErrorData: '',

   

        workLocationTypeErrorText: false,
        workLocationTypeErrorData: '',


        vaccinationErrorText: false,
        vaccinationErrorData: '',

        userDetails:{},

        subTitle: Constants.ADD_EMPLOYEE

    }

    this.isComponentStillMounted = true

    this.nameComponent = null
    this.nameSection = null

    this.genderComponent = null
    this.genderSection = null

    this.addressComponent = null
    this.addressSection = null
    

    this.altMobileComponent = null
    this.altMobileSection = null

    this.codeComponent = null
    this.codeSection = null

    this.emailComponent = null
    this.emailSection = null

    this.mobileComponent = null
    this.mobileSection = null

    this.cityIdComponent = null
    this.cityIdSection = null

    this.statusComponent = null
    this.statusSection = null

    this.designationIdComponent = null
    this.designationIdSection = null

    this.reportingManagerIdComponent = null
    this.reportingManagerIdSection = null


    this.departmentIdComponent = null
    this.departmentIdSection = null

    this.departmentTeamIdComponent = null
    this.departmentTeamIdSection = null

    this.workLocationIdComponent = null
    this.workLocationIdSection = null

    this.workKitchenIdComponent = null
    this.workKitchenIdSection = null

    this.categoryComponent = null
    this.categorySection = null

    this.ragComponent = null
    this.ragSection = null

    this.workLocationTypeComponent = null
    this.workLocationTypeSection = null

    this.vaccinationComponent = null
    this.vaccinationSection = null

    this.accountHolderNameComponent = null
    this.accountHolderNameSection = null

    this.accountNumberComponent = null
    this.accountNumberSection = null
    
    this.ifscCodeComponent = null
    this.ifscCodeSection = null

    this.bankNameComponent = null
    this.bankNameSection = null

    this.accountTypeComponent = null
    this.accountTypeSection = null
    
    this.loginTypeComponent = null
    this.loginTypeSection = null
        
    this.aadhaarNoComponent = null
    this.aadhaarNoSection = null
        
    this.panNoComponent = null
    this.panNoSection = null
     

}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditEmployeeReady(false))

    if (this.props.employees && this.props.employees.employeesSelectedId && this.props.employees.employeesSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_EMPLOYEE))
        this.setState({
            subTitle: "Edit Employee",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_EMPLOYEE))
        this.setState({
            subTitle: "Add Employee"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()

    this.getRolesComboList()        

    }


componentDidMount() {

        this.nameSection = ReactDOM.findDOMNode(this.refs.nameSection)
        this.codeSection = ReactDOM.findDOMNode(this.refs.codeSection)
        this.emailSection = ReactDOM.findDOMNode(this.refs.emailSection)
        this.mobileSection = ReactDOM.findDOMNode(this.refs.mobileSection)
        this.cityIdSection = ReactDOM.findDOMNode(this.refs.cityIdSection)
        this.designationIdSection = ReactDOM.findDOMNode(this.refs.designationIdSection)
        this.categorySection = ReactDOM.findDOMNode(this.refs.categorySection)
        this.ragSection = ReactDOM.findDOMNode(this.refs.ragSection)
        this.vaccinationSection = ReactDOM.findDOMNode(this.refs.vaccinationSection)
        this.departmentIdSection = ReactDOM.findDOMNode(this.refs.departmentIdSection)
        this.departmentTeamIdSection = ReactDOM.findDOMNode(this.refs.departmentTeamIdSection)
        this.workLocationIdSection = ReactDOM.findDOMNode(this.refs.workLocationIdSection)
        this.reportingManagerIdSection = ReactDOM.findDOMNode(this.refs.reportingManagerIdSection)
        this.genderSection = ReactDOM.findDOMNode(this.refs.genderSection)
        this.workKitchenIdSection = ReactDOM.findDOMNode(this.refs.workKitchenIdSection)
        this.workLocationTypeSection = ReactDOM.findDOMNode(this.refs.workLocationTypeSection)
        this.statusSection = ReactDOM.findDOMNode(this.refs.statusSection)
        this.altMobileSection = ReactDOM.findDOMNode(this.refs.altMobileSection)
        this.addressSection = ReactDOM.findDOMNode(this.refs.addressSection)
        this.accountHolderNameSection = ReactDOM.findDOMNode(this.refs.accountHolderNameSection)
        this.accountNumberSection = ReactDOM.findDOMNode(this.refs.accountNumberSection)
        this.ifscCodeSection = ReactDOM.findDOMNode(this.refs.ifscCodeSection)
        this.bankNameSection = ReactDOM.findDOMNode(this.refs.bankNameSection)
        this.accountTypeSection = ReactDOM.findDOMNode(this.refs.accountTypeSection)
        this.loginTypeSection = ReactDOM.findDOMNode(this.refs.loginTypeSection)        
        this.aadhaarNoSection = ReactDOM.findDOMNode(this.refs.aadhaarNoSection)
        this.panNoSection = ReactDOM.findDOMNode(this.refs.panNoSection)
        

}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}


renderSelectOption = (data) => {

    let privilegesList = data;
    let temp = '<select id="userRoleId" class="form-control">';
    for (let i = 0; i < privilegesList.length; i++) {
        temp += '<option value="' + privilegesList[i][0] + '">' + privilegesList[i][1] + '</option>';
    }
    temp += '</select>';
    let selectedElement = document.getElementById("selectIdRender");
    selectedElement.innerHTML = "";
    selectedElement.innerHTML = temp;


    //selectIdRender
}


getRolesComboList = () => {
    apiService.getRolesComboList()
        .then(responseData => {
            if (responseData) {

                if (responseData && responseData.data) {
                    let data = Object.entries(responseData.data);

                    this.setState({
                        rolesList: data
                    })
                    if(!this.state.editFlag){
                        this.renderSelectOption(data)
                        this.props.dispatch(addEditEmployeeReady(true))
                    }else{
                        if(this.props.employees && this.props.employees.employeesSelectedId && this.props.employees.employeesSelectedId !== null) {
                                this.getEmployeeById(this.props.employees.employeesSelectedId)
                        }
                    }                    

                }

            }
        })
        .catch(err => {
            console.error("Error data: ", err)
            this.props.dispatch(addEditEmployeeReady(true))
        })
}


onSaveClick = () => {

    this.props.dispatch(addEditEmployeeReady(false))
    let data = {}

    let nameObject = this.mandateValidation("name", Constants.FORM_INPUT)
    if (nameObject.status) {
        data.name = this.nameComponent.value
    } else {

         this.props.dispatch(addEditEmployeeReady(true))
        return
    }

    if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user) || !this.state.editFlag){
        let codeObject = this.mandateValidation("code", Constants.FORM_INPUT)
        if (codeObject.status) {
            data.code = this.codeComponent.value
        } else {
             this.props.dispatch(addEditEmployeeReady(true))
            return
        }
    }
    


    let genderObject = this.mandateValidation("gender", Constants.FORM_SELECT)
    if (genderObject.status) {
        data.gender = this.genderComponent.value
    } else {
         this.genderComponent.focus()
         this.props.dispatch(addEditEmployeeReady(true))
        return
    }



    if(this.loginTypeComponent && this.loginTypeComponent.value==="Email" && this.state.selectedRoles.length>0){

        let emailObject = this.mandateValidation("email", Constants.FORM_INPUT)
        if (emailObject.status) {
            if(ValidateEmail(this.emailComponent.value)){
                data.email = this.emailComponent.value
            }else{
                this.dialog.show({
                    title: "Error",
                    body: "Please enter valid email id.",
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })

               this["emailSection"].className = this["emailSection"].className.replace(" has-error", "")
               this["emailSection"].className += " has-error"
               this["emailComponent"].focus()
                this.props.dispatch(addEditEmployeeReady(true))
                return
            }        
        } else {
            this.props.dispatch(addEditEmployeeReady(true))
            return
        }

    }else{
        data.email = this.emailComponent.value
    }



    let mobileObject = this.mandateValidation("mobile", Constants.FORM_INPUT)
    if (mobileObject.status) {
        
        if(ValidatePhone(this.mobileComponent.value)){
            data.mobile = this.mobileComponent.value
        }else{
            this.dialog.show({
                title: "Error",
                body: "Please enter valid 10 digit mobile number.",
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })

            this["mobileSection"].className = this["mobileSection"].className.replace(" has-error", "")
            this["mobileSection"].className += " has-error"
            this["mobileComponent"].focus()
            this.props.dispatch(addEditEmployeeReady(true))
            return
        }
    } else {
         this.props.dispatch(addEditEmployeeReady(true))
        return
    }


    if(this.altMobileComponent.value!=="" && this.altMobileComponent.value!==undefined){
    if(ValidatePhone(this.altMobileComponent.value)){
            data.alt_mobile = this.altMobileComponent.value
        }else{
            this.dialog.show({
                title: "Error",
                body: "Please enter valid 10 digit alternative mobile number or leave it blank.",
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })

            this["altMobileSection"].className = this["altMobileSection"].className.replace(" has-error", "")
            this["altMobileSection"].className += " has-error"
            this["altMobileComponent"].focus()
            this.props.dispatch(addEditEmployeeReady(true))
            return
        }
    }else{
        data.alt_mobile = this.altMobileComponent.value
    }

    data.address = this.addressComponent.value


     let cityIdObject = this.mandateValidation("cityId", Constants.FORM_SELECT)
    if (cityIdObject.status) {
        data.city_id = this.cityIdComponent.value
    } else {
        this.cityIdComponent.focus()
         this.props.dispatch(addEditEmployeeReady(true))
        return
    }

      if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user) || !this.state.editFlag){

        let designationIdObject = this.mandateValidation("designationId", Constants.FORM_SELECT)
        if (designationIdObject.status) {
            data.designation_id = this.designationIdComponent.value
        } else {
            this.designationIdComponent.focus()
             this.props.dispatch(addEditEmployeeReady(true))
            return
        }

    }
   

   
    let departmentIdObject = this.mandateValidation("departmentId", Constants.FORM_SELECT)
     if (departmentIdObject.status) {
        data.department_id = this.departmentIdComponent.value
    } else {
         this.props.dispatch(addEditEmployeeReady(true))
        return
    }
   
    let departmentTeamIdObject = this.mandateValidation("departmentTeamId", Constants.FORM_SELECT)
     if (departmentTeamIdObject.status) {
        data.department_team_id = this.departmentTeamIdComponent.value
    } else {
         this.props.dispatch(addEditEmployeeReady(true))
        return
    }
    


  



      let reportingManagerIdObject = this.mandateValidation("reportingManagerId", Constants.FORM_SELECT)
    if (reportingManagerIdObject.status) {
        data.reporting_manager_id = this.reportingManagerIdComponent.value
    } else {
        this.reportingManagerIdComponent.focus()
         this.props.dispatch(addEditEmployeeReady(true))
        return
    }



    let workLocationTypeObject = this.mandateValidation("workLocationType", Constants.FORM_SELECT)
    if (workLocationTypeObject.status) {
        data.work_location_type = this.workLocationTypeComponent.value
    } else {
        this.workLocationTypeComponent.focus()
        this.props.dispatch(addEditEmployeeReady(true))
        return
    }

    if(this.workLocationTypeComponent.value!=="Kitchen"){
        let workLocationIdObject = this.mandateValidation("workLocationId", Constants.FORM_SELECT)
        if (workLocationIdObject.status) {
            data.work_location_id = this.workLocationIdComponent.value
        } else {
            this.workLocationIdComponent.focus()
            this.props.dispatch(addEditEmployeeReady(true))
            return
        }

    }else if(this.workLocationTypeComponent.value==="Kitchen"){
        let workKitchenIdObject = this.mandateValidation("workKitchenId", Constants.FORM_SELECT)
        if (workKitchenIdObject.status) {
            data.work_location_id = this.workKitchenIdComponent.value
        } else {
            this.workKitchenIdComponent.focus()
            this.props.dispatch(addEditEmployeeReady(true))
            return
        }
    }


    



    let vaccinationObject = this.mandateValidation("vaccination", Constants.FORM_SELECT)
    if (vaccinationObject.status) {
        data.vaccination = this.vaccinationComponent.value
    } else {
            this.vaccinationComponent.focus()
         this.props.dispatch(addEditEmployeeReady(true))
        return
    }


    if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)  || !this.state.editFlag){

        let categoryObject = this.mandateValidation("category", Constants.FORM_SELECT)
        if (categoryObject.status) {
            data.category = this.categoryComponent.value
        } else {
                this.categoryComponent.focus()
             this.props.dispatch(addEditEmployeeReady(true))
            return
        }
    }

    let ragObject = this.mandateValidation("rag", Constants.FORM_SELECT)
    if (ragObject.status) {
        data.rag = this.ragComponent.value
    } else {
            this.ragComponent.focus()
         this.props.dispatch(addEditEmployeeReady(true))
        return
    }

     let aadharNoObject = this.mandateValidation("aadhaarNo", Constants.FORM_INPUT)
        if (aadharNoObject.status) {
            
            if(ValidateAadhaar(this.aadhaarNoComponent.value)){
                data.aadhar_no = this.aadhaarNoComponent.value
            }else{
                this.dialog.show({
                    title: "Error",
                    body: "Please enter valid 12 Aadhaar number.",
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })

                this["aadhaarNoSection"].className = this["aadhaarNoSection"].className.replace(" has-error", "")
                this["aadhaarNoSection"].className += " has-error"
                this["aadhaarNoComponent"].focus()
                this.props.dispatch(addEditEmployeeReady(true))
                return
            }
        } else {
             this.props.dispatch(addEditEmployeeReady(true))
            return
        }

     // if(!Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){


     //    let aadharNoObject = this.mandateValidation("aadhaarNo", Constants.FORM_INPUT)
     //    if (aadharNoObject.status) {
            
     //        if(ValidateAadhaar(this.aadhaarNoComponent.value)){
     //            data.aadhar_no = this.aadhaarNoComponent.value
     //        }else{
     //            this.dialog.show({
     //                title: "Error",
     //                body: "Please enter valid 12 Aadhaar number.",
     //                actions: [
     //                    Dialog.OKAction(() => {
     //                    })
     //                ],
     //            })

     //            this["aadhaarNoSection"].className = this["aadhaarNoSection"].className.replace(" has-error", "")
     //            this["aadhaarNoSection"].className += " has-error"
     //            this["aadhaarNoComponent"].focus()
     //            this.props.dispatch(addEditEmployeeReady(true))
     //            return
     //        }
     //    } else {
     //         this.props.dispatch(addEditEmployeeReady(true))
     //        return
     //    }

     // }else{
     //    data.aadhar_no=this.aadhaarNoComponent.value;
     // }



     data.dob=this.state.dob;
     data.doj=this.state.doj;


     if((this.state.employeeData && this.state.employeeData.users && this.state.employeeData.users.length===0) || !this.state.editFlag){
            if(this.loginTypeComponent.value==="Email"){
                data.username=this.emailComponent.value
            }else if(this.loginTypeComponent.value==="Mobile"){
                data.username=this.mobileComponent.value
            }

     }


    data.user_roles = this.state.selectedRoles

    if(this.state.deletedRoles.length>0){
            data.user_roles=data.user_roles.concat(this.state.deletedRoles)
    }

    let bank_details={}
    
     if(this.state.employeeData && this.state.employeeData.bank_details && this.state.employeeData.bank_details.length>0 && this.state.editFlag){
        bank_details.bank_detail_id=this.state.employeeData.bank_details[0].id
    }

    if(this.accountHolderNameComponent.value!=="" && this.accountHolderNameComponent.value!==undefined &&
        this.accountNumberComponent.value!=="" && this.accountNumberComponent.value!==undefined &&
        this.bankNameComponent.value!=="" && this.bankNameComponent.value!==undefined &&
        this.accountTypeComponent.value!=="" && this.accountTypeComponent.value!==undefined &&
        this.accountTypeComponent.value!=="" && this.accountTypeComponent.value!==undefined) {


            bank_details.account_holder_name=this.accountHolderNameComponent.value
            bank_details.account_number=this.accountNumberComponent.value
            bank_details.bank_name=this.bankNameComponent.value
            bank_details.ifsc_code=this.ifscCodeComponent.value
            bank_details.account_type=this.accountTypeComponent.value

            data.bank_details=bank_details

    }else if((this.accountHolderNameComponent.value!=="" && this.accountHolderNameComponent.value!==undefined) ||
        (this.accountNumberComponent.value!=="" && this.accountNumberComponent.value!==undefined ) ||
        (this.bankNameComponent.value!=="" && this.bankNameComponent.value!==undefined ) ||
        (this.accountTypeComponent.value!=="" && this.accountTypeComponent.value!==undefined) ||
        (this.accountTypeComponent.value!=="" && this.accountTypeComponent.value!==undefined)){

        this.dialog.show({
                            title: "Error",
                            body: "If you want to add/update bank details, please update all bank fields or else leave all bank fields empty.",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })

        this.props.dispatch(addEditEmployeeReady(true))
        return
    }



     data.pan_no=this.panNoComponent.value;

    let apiPayloadData=data;


    let validateData={}

    if(this.state.editFlag){
        validateData.id=this.state.employeeData.id
    }

   validateData.code=data.code
   validateData.mobile=data.mobile

   if(data.email && data.email!=="test@hybb.in" && data.email!==undefined && data.email!==""){
        validateData.email=data.email
   }


    // let validResponse=Helpers.validateEmployee(validateData);

      
    // if(validResponse){

    // }


    if(this.state.editFlag){

        if(this.state.employeeData.users.length>0){
            apiPayloadData.user_id=this.state.employeeData.users[0].id
        }else{
            apiPayloadData.user_id=null;
        }

        apiService.editEmployee(apiPayloadData,this.state.employeeData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditEmployeeReady(true))
                        this.props.history.push("/dashboard/employees/list")
                    } else {

                        this.props.dispatch(addEditEmployeeReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditEmployeeReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addEmployee(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditEmployeeReady(true))
                        this.props.history.push("/dashboard/employees/list")
                    } else {

                        this.props.dispatch(addEditEmployeeReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditEmployeeReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getEmployeeById = (id) => {
    apiService.getEmployeeById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({

                        employeeData: responseData.data,
                        name:responseData.data.name,
                        email:responseData.data.email,
                        code:responseData.data.code,
                        mobile:responseData.data.mobile,
                        cityId : responseData.data.city_id,
                        designationId : responseData.data.designation_id,
                        category : responseData.data.category,
                        rag : responseData.data.rag,
                        vaccination : responseData.data.vaccination,
                        departmentId : responseData.data.department_id, 
                        departmentTeamId : responseData.data.department_team_id,        
                        workLocationId : responseData.data.work_location_id,   
                        reportingManagerId : responseData.data.reporting_manager_id, 
                        workLocationType : responseData.data.work_location_type, 
                        workKitchenId : responseData.data.work_location_id,        
                        gender : responseData.data.gender,                  
                        status : responseData.data.status,                
                        dob : responseData.data.dob,                
                        doj : responseData.data.doj,               
                        altMobile : responseData.data.alt_mobile,  
                        address : responseData.data.address,   
                        aadhaarNo : responseData.data.aadhar_no, 
                        pan : responseData.data.pan_no,            
                    })


                    if(responseData.data.users.length===0){

                        this.loginTypeComponent.value="Email"
                    }



                    if (this.isComponentStillMounted) {
                        this.nameComponent.value=responseData.data.name
                        this.emailComponent.value=responseData.data.email
                        this.codeComponent.value=responseData.data.code
                        this.mobileComponent.value=responseData.data.mobile
                        this.categoryComponent.value=responseData.data.category
                        this.altMobileComponent.value=responseData.data.alt_mobile
                        this.addressComponent.value=responseData.data.address
                        this.ragComponent.value=responseData.data.rag
                        this.aadhaarNoComponent.value=responseData.data.aadhar_no
                        this.panNoComponent.value=responseData.data.pan_no
                        this.workLocationTypeComponent.value=responseData.data.work_location_type
                        if(responseData.data.bank_details && responseData.data.bank_details.length>0){
                            this.bankNameComponent.value=responseData.data.bank_details[0].bank_name
                            this.accountNumberComponent.value=responseData.data.bank_details[0].account_number
                            this.accountHolderNameComponent.value=responseData.data.bank_details[0].account_holder_name
                            this.ifscCodeComponent.value=responseData.data.bank_details[0].ifsc_code
                            this.accountTypeComponent.value=responseData.data.bank_details[0].account_type
                            this.setState({
                                accountType:responseData.data.bank_details[0].account_type
                            })
                        }
                    }


                    this.filterData(responseData.data) 
            

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditEmployeeReady(true))
        })
}


validateEmployee = (keyedName)=>{
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
        if(name!=="" && name!==undefined){    

            let validateData={}
            if(keyedName==="code"){
                validateData={
                    "validation":{
                        "type":"code",
                        "value":name
                    }
                }

            }else if(keyedName==="aadhaarNo"){
                validateData={
                        "validation":{
                            "type":"aadhar_no",
                            "value":name
                        }
                    }
                
            }

            if(this.state.editFlag){
                validateData.id=this.props.employees.employeesSelectedId
            }
                

                 apiService.validateEmployee(validateData)
                    .then(userData => {                
                       if(userData.exist_employee_count>0){
                            this.setState({
                                isValidEmployee:false,
                                errorMsg:"This Employee "+keyedName+" [ "+name+" ] is already taken, please check!!" 
                            });

                           this.dialog.show({
                            title: "Alert",
                            body: "This Employee "+keyedName+" [ "+name+" ] is already taken, please check!!",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                       }else{
                            this.setState({
                                isValidEmployee:true 
                            });
                       }
                    })
                    .catch(err => {
                        console.log(err);
                    }) 
            }
}


filterData = (data) => {

    if(data.users[0]){

            let roleData=[]

            let user_roles=data.users[0].user_roles;

            for(let i=0;i<user_roles.length;i++){
            
                let temp={}

                temp['user_role_id']=user_roles[i].id;
                temp['role_id']=user_roles[i].role_id;

                 roleData.push(temp)
            }

            this.setState({
                selectedRoles: roleData
            });

            let rolesList = this.state.rolesList
            let selectedRoles = this.state.selectedRoles

            //let index = rolesList.indexOf(selectedValue);

            selectedRoles.map(function(item) {
                rolesList.map(function(item2,index) {
                    if (parseInt(item2[0],10) === item.role_id) {
                        item['role_name']=item2[1]
                        if (index > -1) {
                            rolesList.splice(index, 1); // 2nd parameter means remove one item only
                        }
                    }
                    return true
                });
                return true
            })

             this.setState({
                selectedRoles: selectedRoles
            });



            this.setState({
                rolesList: rolesList
               }); 


        this.renderSelectOption(rolesList)
        
        this.props.dispatch(addEditEmployeeReady(true)) 
    }else{
        this.renderSelectOption(this.state.rolesList)
        
        this.props.dispatch(addEditEmployeeReady(true)) 
    }
}


dobChange = (newDate) => {

    let dob=Helpers.getDateFormatForUTC(parseInt(newDate,10));

    this.setState({
        dob: dob
    });

}

dojChange = (newDate) => {

    let doj=Helpers.getDateFormatForUTC(parseInt(newDate,10));

    this.setState({
        doj: doj
    });

}






addRoleBtn = () => {

    let selectedValueId = document.getElementById("userRoleId").value;
    let selectedValueText = document.getElementById("userRoleId").options[document.getElementById("userRoleId").selectedIndex].text;
    let selectedRoles = this.state.selectedRoles;

    let deletedRoles = this.state.deletedRoles;

    if(this.state.editFlag){
        let index_d;
        let user_role_id;
         deletedRoles.map(function(item, index) {
            if (item['role_id'] === selectedValueId) {
                index_d = index
                user_role_id=item['user_role_id']
            }
            return true
        })

         selectedRoles.push({
            "user_role_id":user_role_id,
            "role_id": selectedValueId,
            "role_name": selectedValueText
        });

        if (index_d > -1) {
            deletedRoles.splice(index_d, 1); // 2nd parameter means remove one item only
        }



    }else{

        selectedRoles.push({
            "role_id": selectedValueId,
            "role_name": selectedValueText
        });
    }
    

    this.setState({
        selectedRoles: selectedRoles
    });


    let rolesList = this.state.rolesList

    //let index = rolesList.indexOf(selectedValue);
    let index_i;
    rolesList.map(function(item, index) {
        if (item[0] === selectedValueId) {
            index_i = index
        }
        return true
    })

    if (index_i > -1) {
        rolesList.splice(index_i, 1); // 2nd parameter means remove one item only
    }

    this.setState({
        rolesList: rolesList
    });

    this.renderSelectOption(this.state.rolesList)
}


removeRole = (role_id) => {

    let selectedRoles = this.state.selectedRoles;
    let deletedRoles = this.state.deletedRoles;


    let index_i;
    let role_name;

    selectedRoles.map(function(item, index) {
        if (item['role_id'] === role_id) {
            index_i = index
            role_name = item['role_name']
        }
        return true
    })

    if(this.state.editFlag && selectedRoles[index_i]['user_role_id']){

        selectedRoles[index_i]['is_deleted']=1
        deletedRoles.push(selectedRoles[index_i])

        this.setState({
            deletedRoles: deletedRoles
        });
    }

    if (index_i > -1) {        
            selectedRoles.splice(index_i, 1);
    }

    this.setState({
        selectedRoles: selectedRoles
    });

    let rolesList = this.state.rolesList

    rolesList.push([role_id, role_name]);

    this.setState({
        rolesList: rolesList
    });

    this.renderSelectOption(this.state.rolesList)

}




designationChange= (data) => {
    this.designationIdComponent.value=data.value
        this.setState({
            designationId :data.value,
            designationIdErrorText: false,
            designationIdErrorData: ''
        })
        this.designationIdSection.className= this.designationIdSection.className.replace(" has-error", "")
    }


  reportingManagerChange= (data) => {
    this.reportingManagerIdComponent.value=data.value
        this.setState({
            reportingManagerId :data.value,
            reportingManagerIdErrorText: false,
            reportingManagerIdErrorData: ''
        })
        this.reportingManagerIdSection.className= this.reportingManagerIdSection.className.replace(" has-error", "")
    }

    genderChange= (data) => {
        this.genderComponent.value=data.value
            this.setState({
                gender :data.value,
                genderErrorText: false,
                genderErrorData: ''
            })
            this.genderSection.className= this.genderSection.className.replace(" has-error", "")
    }

    

    departmentChange= (data) => {
    this.departmentIdComponent.value=data.value
        this.setState({
            departmentId :data.value,
            departmentTeamId : "",
            departmentIdErrorText: false,
            departmentIdErrorData: ''
        })
        this.departmentIdSection.className= this.departmentIdSection.className.replace(" has-error", "")
    }

    

    departmentTeamChange= (data) => {
    this.departmentTeamIdComponent.value=data.value
        this.setState({
            departmentTeamId :data.value,
            departmentTeamIdErrorText: false,
            departmentTeamIdErrorData: ''
        })
        this.departmentTeamIdSection.className= this.departmentTeamIdSection.className.replace(" has-error", "")
    }



workLocationChange= (data) => {
    this.workLocationIdComponent.value=data.value
        this.setState({
            workLocationId :data.value,
            workLocationIdErrorText: false,
            workLocationIdErrorData: ''
        })
        this.workLocationIdSection.className= this.workLocationIdSection.className.replace(" has-error", "")
    }


workLocationTypeChange= (data) => {
    this.workLocationTypeComponent.value=data.value
        this.setState({
            workLocationType :data.value,
            workLocationTypeErrorText: false,
            workLocationTypeErrorData: ''
        })
        this.workLocationTypeSection.className= this.workLocationTypeSection.className.replace(" has-error", "")
    }


    accountTypeChange= (data) => {
        this.accountTypeComponent.value=data.value
        this.setState({
            accountType :data.value,
            accountTypeErrorText: false,
            accountTypeErrorData: ''
        })
        this.accountTypeSection.className= this.accountTypeSection.className.replace(" has-error", "")
    }




kitchenChange= (data) => {
    this.workKitchenIdComponent.value=data.value
        this.setState({
            workKitchenId :data.value,
            workKitchenIdErrorText: false,
            workKitchenIdErrorData: ''
        })
        this.workKitchenIdSection.className= this.workKitchenIdSection.className.replace(" has-error", "")
    }


   cityChange = (data) => {
    this.cityIdComponent.value=data.value
        this.setState({
            cityId :data.value,
            cityIdErrorText: false,
            cityIdErrorData: ''
        })
        this.cityIdSection.className= this.cityIdSection.className.replace(" has-error", "")
    }

   statusChange = (data) => {
    this.statusComponent.value=data.value
        this.setState({
            status :data.value,
            statusErrorText: false,
            statusErrorData: ''
        })
        this.statusSection.className= this.statusSection.className.replace(" has-error", "")
    }






   ragChange = (data) => {
    this.ragComponent.value=data.value
        this.setState({
            rag :data.value,
            ragErrorText: false,
            ragErrorData: ''
        })
        this.ragSection.className= this.ragSection.className.replace(" has-error", "")
    }




   categoryChange = (data) => {
    this.categoryComponent.value=data.value
        this.setState({
            category :data.value,
            categoryErrorText: false,
            categoryErrorData: ''
        })
        this.categorySection.className= this.categorySection.className.replace(" has-error", "")
    }

    loginTypeChange= (data) => {
        this.loginTypeComponent.value=data.value
        this.setState({
            loginType :data.value,
            loginTypeErrorText: false,
            loginTypeErrorData: ''
        })
        this.loginTypeSection.className= this.loginTypeSection.className.replace(" has-error", "")
    }




   vaccinationChange = (data) => {
    this.vaccinationComponent.value=data.value
        this.setState({
            vaccination :data.value,
            vaccinationErrorText: false,
            vaccinationErrorData: ''
        })
        this.vaccinationSection.className= this.vaccinationSection.className.replace(" has-error", "")
    }



    render() {
        return (<div className="line-item-edit">


            {(()=>{

                if(!this.state.isValidEmployee){
                    return(
                            <div style={{margin: "0px 20%"}}>
            
            <p style={{position: "fixed",background: "white",color: "red",textAlign: "center",
                width: "50%",zIndex: 4,padding: "1% 1%",
                border: "1px solid #ff000021"}}>{this.state.errorMsg}</p>
            </div>
                        )
                }
            
            })()}
            
   <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
   <a href="" 
      onClick={(e) => {e.preventDefault() 
   this.props.history.goBack()}}> 
   <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
   </a>
</div>
<Dialog ref={el =>
this.dialog = el} />
<section className="content">
   <div className="row">
      <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
         <div className="box box-info" style={{ borderTop: "0px" }}>
         <div className="box-header with-border">
            <h3 className="box-title" style={{ fontWeight: 600 }}>Basic Information</h3>
         </div>
         <div className="form-horizontal">
            <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
            <div className="col-md-12 col-sm-12 col-xs-12">
               <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group" ref={el =>
                     this.nameSection = el}>
                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Full Name *</label>
                     <div className="col-sm-9">
                        <input className="form-control" placeholder="Enter Name" type="text" ref={el => this.nameComponent = el}
                        onChange={(e) => {e.preventDefault() 
                        this.keyedInputChange("name")}} />
                        <span className="help-block"style={{display: this.state.nameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                        {this.state.nameErrorData}
                        </span>
                     </div>
                  </div>
               </div>

               <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group" ref={el =>
                     this.codeSection = el}>
                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee ID *</label>
                     <div className="col-sm-9" >

                      {(() =>{

    if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)  || !this.state.editFlag){
            return(     
                    <input className="form-control" placeholder="Enter Employee id" type="number" ref={el => this.codeComponent = el}
                        onBlur={(e) => { 
                        this.validateEmployee("code")}} />
                )
            }else{
                return(

                    <input className="form-control" placeholder="Enter Employee id" type="number" ref={el => this.codeComponent = el}
                        onChange={(e) => {e.preventDefault() 
                        this.keyedInputChange("code")}} disabled={this.state.disabledFlag}/>

            )
        }
})()}

                        <span className="help-block" style={{ display: this.state.codeErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                        {this.state.codeErrorData}
                        </span>
                     </div>
                  </div>
               </div>

            </div>
            <div className="col-md-12 col-sm-12 col-xs-12">
               <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group" ref={el =>
                     this.genderSection = el}>
                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Gender *</label>
                     <div className="col-sm-9" ref={el =>
                        this.genderComponent = el}>
                        <Gender genderChange={this.genderChange} selectedValue={this.state.gender} />
                        <span className="help-block" style={{ display: this.state.genderErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                        {this.state.genderErrorData}
                        </span>
                     </div>
                  </div>
               </div>
               <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group" ref={el =>
                     this.emailSection = el}>
                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Email Id</label>
                     <div className="col-sm-9">
                        <input className="form-control" placeholder="Enter Email id" type="text" ref={el => this.emailComponent = el}
                        onChange={(e) => {e.preventDefault() 
                        this.keyedInputChange("email")}} />
                        <span className="help-block"style={{display: this.state.emailErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                        {this.state.emailErrorData}
                        </span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12">
               <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group" ref={el =>
                     this.mobileSection = el}>
                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Primary Mobile No *</label>
                     <div className="col-sm-9">
                        <input className="form-control" placeholder="Enter Mobile No" type="number" ref={el => this.mobileComponent = el}
                        onChange={(e) => {e.preventDefault() 
                        this.keyedInputChange("mobile")}} />
                        <span className="help-block" style={{ display: this.state.mobileErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                        {this.state.mobileErrorData}
                        </span>
                     </div>
                  </div>
               </div>
               <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group">
                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>D.O.B *</label>
                     <div className="col-sm-9">
                        <DateTimeField mode="date" inputFormat="DD-MM-YYYY" dateTime={new Date(this.state.dob)} onChange={this.dobChange}/>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12">
               <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group" ref={el =>
                     this.altMobileSection = el}>
                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Alternative Mobile No </label>
                     <div className="col-sm-9">
                        <input className="form-control" placeholder="Enter Alternative Mobile No" type="number" ref={el => this.altMobileComponent = el}
                        onChange={(e) => {e.preventDefault() 
                        this.keyedInputChange("altMobile")}} />
                        <span className="help-block" style={{ display: this.state.altMobileErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                        {this.state.altMobileErrorData}
                        </span>
                     </div>
                  </div>
               </div>
               <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group">
                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>D.O.J *</label>
                     <div className="col-sm-9">
                        <DateTimeField mode="date" inputFormat="DD-MM-YYYY" dateTime={new Date(this.state.doj)} onChange={this.dojChange}/>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12">
               <div className="col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group" ref={el =>
                     this.addressSection = el}>
                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Communication Address </label>
                     <div className="col-sm-9">
                        <textarea className="form-control" placeholder="Enter Communication Address" ref={el => this.addressComponent = el}
                        onChange={(e) => {e.preventDefault() 
                        this.keyedInputChange("address")}} />
                        <span className="help-block" style={{ display: this.state.addressErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                        {this.state.addressErrorData}
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
         </div>
      </div>
   </div>
   <div className="box box-info" style={{ borderTop: "0px" }}>
   <div className="box-header with-border">
      <h3 className="box-title" style={{ fontWeight: 600 }}>Employment Information</h3>
   </div>
   <div className="form-horizontal">
      <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
      <div className="col-md-12 col-sm-12 col-xs-12">
         
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.cityIdSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City *</label>
               <div className="col-sm-9" ref={el =>
                  this.cityIdComponent = el}>
                  <Cities cityChange={this.cityChange} selectedValue={this.state.cityId} />
                  <span className="help-block" style={{ display: this.state.cityIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.cityIdErrorData}
                  </span>
               </div>
            </div>
         </div>

         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.designationIdSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Designation *</label>
               <div className="col-sm-9" ref={el =>
                  this.designationIdComponent = el}>

                   {(() =>{

     if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)  || !this.state.editFlag){
            return(     



                  <Designations designationChange={this.designationChange} selectedValue={this.state.designationId} />

                      )
                }else{

                    return(

                      <Designations designationChange={this.designationChange} selectedValue={this.state.designationId} disabled={this.state.disabledFlag}/>
                        
                )
            }
    })()}

                  <span className="help-block" style={{ display: this.state.designationIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.designationIdErrorData}
                  </span>
               </div>
            </div>
         </div>

         

         
      </div>
      <div className="col-md-12 col-sm-12 col-xs-12">
            
            <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.departmentIdSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Department *</label>
               <div className="col-sm-9" ref={el =>
                  this.departmentIdComponent = el}>
                  <Departments departmentChange={this.departmentChange} selectedValue={this.state.departmentId} />
                  <span className="help-block" style={{ display: this.state.departmentIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.departmentIdErrorData}
                  </span>
               </div>
            </div>
         </div>

         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.departmentTeamIdSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Department Team *</label>
               <div className="col-sm-9" ref={el =>
                  this.departmentTeamIdComponent = el}>
                  <DepartmentTeams departmentTeamChange={this.departmentTeamChange} selectedValue={this.state.departmentTeamId} selectedDepartment={this.state.departmentId} selectedCity={this.state.cityId} />
                  <span className="help-block" style={{ display: this.state.departmentTeamIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.departmentTeamIdErrorData}
                  </span>
               </div>
            </div>
         </div>
         
      </div>
      <div className="col-md-12 col-sm-12 col-xs-12">
        
        <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.reportingManagerIdSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reporting Manager *</label>
               <div className="col-sm-9" ref={el =>
                  this.reportingManagerIdComponent = el}>
                  <Employees reportingManagerChange={this.reportingManagerChange} selectedValue={this.state.reportingManagerId} />
                  <span className="help-block" style={{ display: this.state.reportingManagerIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.reportingManagerIdErrorData}
                  </span>
               </div>
            </div>
         </div>


         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.workLocationTypeSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Work Location Type *</label>
               <div className="col-sm-9" ref={el =>
                  this.workLocationTypeComponent = el}>

                   <EntityType entityTypeChange={this.workLocationTypeChange} selectedValue={this.state.workLocationType} type="WORK_LOCATIONS" />
                  <span className="help-block" style={{ display: this.state.workLocationTypeErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.workLocationTypeErrorData}
                  </span>
               </div>
            </div>
         </div>
        
      </div>
      <div className="col-md-12 col-sm-12 col-xs-12">

         {(() => {
         if(this.state.workLocationType!=="Kitchen"){
         return (
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.workLocationIdSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Office *</label>
               <div className="col-sm-9" ref={el =>
                  this.workLocationIdComponent = el}>
                  <WorkLocations type={this.state.workLocationType} city_id={this.state.cityId} workLocationChange={this.workLocationChange} selectedValue={this.state.workLocationId} />
                  <span className="help-block" style={{ display: this.state.workLocationIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.workLocationIdErrorData}
                  </span>
               </div>
            </div>
         </div>
         )
         }
         if(this.state.workLocationType==="Kitchen"){
         return (
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.workKitchenIdSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen *</label>
               <div className="col-sm-9" ref={el =>
                  this.workKitchenIdComponent = el}>
                  <Kitchens selectedCity={this.state.cityId} kitchenChange={this.kitchenChange} selectedValue={this.state.workKitchenId} />
                  <span className="help-block" style={{ display: this.state.workKitchenIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.workKitchenIdErrorData}
                  </span>
               </div>
            </div>
         </div>
         )
         }
         })()}
        

         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.vaccinationSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Covid-19 Vaccination *</label>
               <div className="col-sm-9" ref={el =>
                  this.vaccinationComponent = el}>
                  <Vaccination vaccinationChange={this.vaccinationChange} selectedValue={this.state.vaccination} />
                  <span className="help-block" style={{ display: this.state.vaccinationErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.vaccinationErrorData}
                  </span>
               </div>
            </div>
         </div>
      </div>


      <div className="col-md-12 col-sm-12 col-xs-12">
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.categorySection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Category *</label>
               <div className="col-sm-9" ref={el =>
                  this.categoryComponent = el}>


                   {(() =>{

     if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)  || !this.state.editFlag){
            return(   


                  <EntityType entityTypeChange={this.categoryChange} selectedValue={this.state.category} type="EMPLOYEE_CATEGORY" />

                    )
                }else{

                    return(
                         <EntityType entityTypeChange={this.categoryChange} selectedValue={this.state.category} type="EMPLOYEE_CATEGORY" disabled={this.state.disabledFlag} />

                )
            }
    })()}
                  <span className="help-block" style={{ display: this.state.categoryErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.categoryErrorData}
                  </span>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.ragSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>RAG *</label>
               <div className="col-sm-9" ref={el =>
                  this.ragComponent = el}>
                  <RAG ragChange={this.ragChange} selectedValue={this.state.rag} />
                  <span className="help-block" style={{ display: this.state.ragErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.ragErrorData}
                  </span>
               </div>
            </div>
         </div>
      </div>

        <div className="col-md-12 col-sm-12 col-xs-12">
                            
             <div className="col-md-6 col-sm-12 col-xs-12">
                <div className="form-group" ref={el =>
                   this.aadhaarNoSection = el}>
                   <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Aadhaar No *</label>
                   <div className="col-sm-9">
                      <input className="form-control" placeholder="Enter Aadhaar No" type="number" ref={el => this.aadhaarNoComponent = el}
                     

                        onBlur={(e) => { 
                        this.validateEmployee("aadhaarNo")}}
                        />
                      <span className="help-block" style={{ display: this.state.aadhaarNoErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                      {this.state.aadhaarNoErrorData}
                      </span>
                   </div>
                </div>
             </div>                        
             <div className="col-md-6 col-sm-12 col-xs-12">
                <div className="form-group" ref={el =>
                   this.panNoSection = el}>
                   <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>PAN No </label>
                   <div className="col-sm-9">
                      <input className="form-control" placeholder="Enter PAN No" type="text" ref={el => this.panNoComponent = el}
                      onChange={(e) => {e.preventDefault() 
                      this.keyedInputChange("panNo")}} />
                      <span className="help-block" style={{ display: this.state.panNoErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                      {this.state.panNoErrorData}
                      </span>
                   </div>
                </div>
             </div>


        </div>

   </div>
   </div>
   </div>  
   <div className="box box-info" style={{ borderTop: "0px" }}>
   <div className="box-header with-border">
      <h3 className="box-title" style={{ fontWeight: 600 }}>Bank Details</h3>
   </div>
   <div className="form-horizontal">
      <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
      <div className="col-md-12 col-sm-12 col-xs-12">
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.accountHolderNameSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Account Holder Name </label>
               <div className="col-sm-9">
                  <input className="form-control" placeholder="Enter Account Holder Name" type="text" ref={el => this.accountHolderNameComponent = el}
                  onChange={(e) => {e.preventDefault() 
                  this.keyedInputChange("accountHolderName")}} />
                  <span className="help-block" style={{ display: this.state.accountHolderNameErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.accountHolderNameErrorData}
                  </span>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.accountNumberSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Account Number </label>
               <div className="col-sm-9">
                  <input className="form-control" placeholder="Enter Account Number" type="number" ref={el => this.accountNumberComponent = el}
                  onChange={(e) => {e.preventDefault() 
                  this.keyedInputChange("accountNumber")}} />
                  <span className="help-block" style={{ display: this.state.accountNumberErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.accountNumberErrorData}
                  </span>
               </div>
            </div>
         </div>
      </div>
      <div className="col-md-12 col-sm-12 col-xs-12">
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.ifscCodeSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>IFSC Code </label>
               <div className="col-sm-9">
                  <input className="form-control" placeholder="Enter IFSC Code" type="text" ref={el => this.ifscCodeComponent = el}
                  onChange={(e) => {e.preventDefault() 
                  this.keyedInputChange("ifscCode")}} />
                  <span className="help-block" style={{ display: this.state.ifscCodeErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.ifscCodeErrorData}
                  </span>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.bankNameSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Bank Name </label>
               <div className="col-sm-9">
                  <input className="form-control" placeholder="Enter Bank Name" type="text" ref={el => this.bankNameComponent = el}
                  onChange={(e) => {e.preventDefault() 
                  this.keyedInputChange("bankName")}} />
                  <span className="help-block" style={{ display: this.state.bankNameErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.bankNameErrorData}
                  </span>
               </div>
            </div>
         </div>
      </div>
      <div className="col-md-12 col-sm-12 col-xs-12">
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.accountTypeSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Account Type</label>
               <div className="col-sm-9" ref={el =>
                  this.accountTypeComponent = el}>
                  <AccountType accountTypeChange={this.accountTypeChange} selectedValue={this.state.accountType} />
                  <span className="help-block" style={{ display: this.state.accountTypeErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.accountTypeErrorData}
                  </span>
               </div>
            </div>
         </div>
      </div>
   </div>
   </div>
   </div>
   <div className="box box-info" style={{ borderTop: "0px" }}>
   <div className="box-header with-border">
      <h3 className="box-title" style={{ fontWeight: 600 }}>Login Details</h3>
   </div>
   <div className="form-horizontal">
      <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
      {(() => {
      if((this.state.employeeData && this.state.employeeData.users && this.state.employeeData.users.length===0) || !this.state.editFlag){
      return (
      <div className="col-md-12 col-sm-12 col-xs-12">
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group" ref={el =>
               this.loginTypeSection = el}>
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Prefered Username</label>
               <div className="col-sm-9" ref={el =>
                  this.loginTypeComponent = el}>
                  <LoginType loginTypeChange={this.loginTypeChange} selectedValue={this.state.loginType} />
                  <span className="help-block" style={{ display: this.state.loginTypeErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                  {this.state.loginTypeErrorData}
                  </span>
               </div>
            </div>
         </div>
      </div>
      )
      }
      })()}
      <div className="col-md-12 col-sm-12 col-xs-12">
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group">
               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select User Role</label>
               <div className="col-sm-9" id="selectIdRender">
                  <select id="userRoleId" className="form-control">
                  </select>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="col-md-6">
               <div className="add-btn-box">
                  <button
                     className="btn btn-info"
                     onClick={(e) => {
                  e.preventDefault()
                  this.addRoleBtn()
                  }}>
                  Add
                  </button>
               </div>
            </div>
         </div>
         {(() => {
         if(this.state.selectedRoles.length>0){
         return (
         <div className="col-md-12">
            <div className="col-md-6">
               <div className="form-horizontal">
                  <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                  <h4>Selected User Roles</h4>
                  <table className="table table-bordered" style={{textAlign:"left"}}>
                     <thead>
                        <tr>
                           <th>User</th>
                           <th>Delete</th>
                        </tr>
                     </thead>
                     <tbody>
                        {this.state.selectedRoles.map((item, index) => (
                        <tr>
                           <td>{this.state.selectedRoles[index].role_name}</td>
                           <td>
                              <button
                                 className="btn btn-danger"
                                 onClick={(e) => {
                              e.preventDefault()
                              this.removeRole(this.state.selectedRoles[index].role_id)
                              }}>
                              X
                              </button>
                           </td>
                        </tr>
                        ))}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </div>
      )
      }
      })()}
   </div>
   </div>
   </div>
   </div>
   <div className="box box-info" style={{ borderTop: "0px" }}>
   <div className="form-horizontal">
      <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
      <div className="box-footer">
         <button
            className="btn btn-default"
            onClick={(e) => {
         e.preventDefault()
         this.onCancelClick()
         }}>
         Cancel
         </button>

         {(()=>{

            if(this.state.isValidEmployee){
                return(
                     <button
                        className="btn btn-info pull-right"
                        onClick={(e) => {
                     e.preventDefault()
                     this.onSaveClick()
                     }}>
                     Save Changes
                     </button>
                    )
            }
         })()}

        
      </div>
   </div>
   </div>
   </div>
   </div>
   </div>
</section>
</div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        employees: state.employees,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditEmployee))


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/AddEditEmployee.js